import { useEffect } from 'react';
import clsx from 'clsx';
import useNotificationMarkAsRead from '../../api/hooks/use-notifications-mark-as-read';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Virtuoso } from 'react-virtuoso';
import { BuyApartmentFlowPaths, NotificationFlowPaths } from '../../routes';
import { MarketTypes } from '../../api/types';
import useApartmentOneFilterNotification from '../../api/hooks/use-apartment-one-filter-notification';
import { ITEMS_PER_PAGE } from '../../lib/constants';
import { ApartmentNavigateProps } from '../apartment';
import ApartmentListItem, {
  APARTMENT_LIST_ITEM_HEIGHT,
} from '../../components/apartment-list-item';
import LoadMoreVirtualListFooter from '../../components/load-more-virtual-list-footer';
import NotFound from '../../components/not-found';
import BaseScreen, { BASE_SCREEN_HEADER_HEIGHT } from '../../components/base-screen';
import ErrorMessage from '../../components/error-message';
import Loader from '../../components/loader';
import styles from '../choose-apartment-complex/styles.module.scss';

export const NotificationOneFilterList = () => {
  const navigate = useNavigate();
  const apartmentId = (useLocation().state as ApartmentNavigateProps)?.id;
  const listStyle = { height: `calc(100vh - ${BASE_SCREEN_HEADER_HEIGHT})` };

  const {
    error,
    total,
    data: notification,
    setSize,
    isLoadingMore,
    isInitialLoading,
  } = useApartmentOneFilterNotification(apartmentId);

  useEffect(() => {
    notification.length && useNotificationMarkAsRead(apartmentId, notification);
  }, [notification]);

  return (
    <BaseScreen title='Уведомления'>
      {error && notification.length === 0 ? (
        <ErrorMessage className={styles.margined} message={error} />
      ) : isInitialLoading ? (
        <Loader className={styles.margined} />
      ) : notification.length > 0 ? (
        <Virtuoso
          useWindowScroll
          context={{
            total,
            loading: isLoadingMore,
            per: ITEMS_PER_PAGE,
            loadedNum: notification.length,
            loadMore: () => setSize((s) => s + 1),
          }}
          data={notification}
          style={listStyle}
          className={styles.container}
          defaultItemHeight={APARTMENT_LIST_ITEM_HEIGHT}
          itemContent={(index, apartment) => (
            <ApartmentListItem
              {...apartment}
              onClick={() =>
                navigate(
                  apartment?.marketType === MarketTypes.SECONDARY
                    ? BuyApartmentFlowPaths.apartmentSecondary
                    : BuyApartmentFlowPaths.apartment,
                  {
                    state: { id: apartment?.facilityId } as ApartmentNavigateProps,
                  },
                )
              }
              className={clsx(index !== 3 - 1 && styles.border)}
            />
          )}
          components={{ Footer: LoadMoreVirtualListFooter }}
        />
      ) : (
        <NotFound />
      )}
    </BaseScreen>
  );
};

export const NotificationOneFilterListNavigation: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    let id = Number(params.id)
    if (id) {
      navigate(NotificationFlowPaths.notificationFilterItem, {
        state: { id: id },
        replace: true
      })
    }
  }, [params])
  return <></>
}
